import { render, staticRenderFns } from "./send-record.vue?vue&type=template&id=f4dd3424&scoped=true&"
import script from "./send-record.vue?vue&type=script&lang=js&"
export * from "./send-record.vue?vue&type=script&lang=js&"
import style0 from "./send-record.vue?vue&type=style&index=0&id=f4dd3424&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dd3424",
  null
  
)

export default component.exports